import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CheckboxController } from '@/components/form/controllers/checkbox-controller';
import { cn } from '@/lib/utils';

import type { EstatesFiltersSchemaType } from '../schemas';
import { DEFAULT_ESTATE_FILTERS_VALUES } from '../schemas/estates-filters';
import { activeFilterFieldClassName, hasActiveFilterValue } from './estate-filter-active-field';

const additionalFeatures: (keyof Pick<
  EstatesFiltersSchemaType,
  'loggia' | 'balcony' | 'garden' | 'parkingSpace' | 'basement' | 'elevator'
>)[] = ['loggia', 'balcony', 'garden', 'parkingSpace', 'basement', 'elevator'];

export const EstateFilterAdditionalFeatures = () => {
  const { t } = useTranslation();

  const methods = useFormContext<EstatesFiltersSchemaType>();

  return (
    <fieldset className="mb-5 grid grid-cols-3 gap-4">
      {additionalFeatures.map((fieldName) => {
        const value = methods.watch(fieldName);
        const isActive = value !== DEFAULT_ESTATE_FILTERS_VALUES[fieldName];

        return (
          <CheckboxController
            key={fieldName}
            methods={methods}
            name={fieldName}
            label={t(fieldName)}
            wrapperClassName={cn(
              'rounded-md p-2',
              isActive && hasActiveFilterValue(value) && activeFilterFieldClassName
            )}
          />
        );
      })}
    </fieldset>
  );
};
